<template>
  <t-section
    v-bind:schemaName="'order'"
    v-bind:defaultSort="'desc'"
    v-bind:isCustomRow="isCustomRow"
    v-bind:fields="fields"
    v-bind:headers="headers"
    v-bind:isHideChart="true"
    addShortLabel="Опт"
    addIcon="fas fa-box-open"
    addButtonClass="order-action-button order-action-button--opt"
  >
    <template v-slot:custom="{ close }">
      <sender-detail v-on:sent="close" />
    </template>
    <template v-slot:buttons>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary order-action-button order-action-button--retail"
        v-bind:title="$filters.localize('button.add-retail')"
        v-on:click="routerRetail"
      >
        <i class="fas fa-shoe-prints"></i>
        <span class="order-action-label order-action-label--full">{{
          $filters.localize("button.add-retail") }}</span>
        <span
          class="order-action-label order-action-label--short">Роздріб</span>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-success order-action-button order-action-button--tailoring"
        v-bind:title="$filters.localize('button.add-tailoring')"
        v-on:click="routerTailoring('Wholesale')"
      >
        <i class="fas fa-tools"></i>
        <span class="order-action-label order-action-label--full">{{
          $filters.localize("button.add-tailoring") }}</span>
        <span class="order-action-label order-action-label--short">Відшив</span>
      </button>
      <button
        type="button"
        class="btn btn-sm btn-outline-primary order-action-button order-action-button--tailoring-retail"
        v-bind:title="$filters.localize('button.add-tailoring-retail')"
        v-on:click="routerTailoring('Retail')"
      >
        <i class="fas fa-drafting-compass"></i>
        <span class="order-action-label order-action-label--full">{{
          $filters.localize("button.add-tailoring-retail") }}</span>
        <span class="order-action-label order-action-label--short">Відшив
          роздріб</span>
      </button>
    </template>
    <template v-slot:count="{ data }">
      <div>Сума наложки: {{ data.sum }} грн</div>
    </template>
    <template v-slot:body="{
      data,
      headers,
      getRowValue,
      pageCount,
    }">
      <tbody
        v-for="(row, index) of data"
        v-bind:key="row.id"
      >
        <tr>
          <td
            v-on:click.prevent="getProducts(row.id)"
            v-if="products.filter((x) => x?.activityId == row.id).length == 0"
          >
            +
          </td>
          <td
            v-on:click.prevent="removeProducts(row.id)"
            v-else
          >-</td>
          <td>{{ index + pageCount }}</td>
          <td
            v-for="header of headers"
            v-bind:key="header.field + row.id"
            v-bind:class="[header.class, { 'order-chip-cell': isChipHeader(row, header, getRowValue) }]"
            v-bind:style="header.style ? header.style : null"
            v-on:click.middle.prevent="
              routerOrder(row, header, true)
              "
            v-on:click.prevent="
              routerOrder(row, header)
              "
          >
            <span
              v-if="header.field === 'kind'"
              class="order-chip"
              v-bind:class="getClassColor(row.kind, header)"
            >
              {{ formatKind(row.kind) }}
            </span>
            <span
              v-else-if="header.field === 'fulfillmentKind'"
              class="order-chip"
              v-bind:class="getClassColor(row.fulfillmentKind || 'Standard', header)"
            >
              {{ formatFulfillment(row.fulfillmentKind || "Standard") }}
            </span>
            <span
              v-else-if="isChipHeader(row, header, getRowValue)"
              class="order-chip"
              v-bind:class="[
                getClassColor(getRowValue(row, header.config), header) || 'row-status-default',
                { 'order-chip--payment-status': header.config?.type === 'paymentStatus' }
              ]"
            >
              {{ formatChipValue(getRowValue(row, header), header, row) }}
            </span>
            <span
              v-else-if="header.field === 'recipient'"
              class="order-recipient-singleline"
              v-bind:title="formatPersonName(getRowValue(row, header))"
            >
              {{ formatPersonName(getRowValue(row, header)) }}
            </span>
            <span
              v-else-if="isPersonNameHeader(header)"
              class="order-compact-name-multiline"
              v-bind:title="formatPersonName(getRowValue(row, header))"
            >
              {{ formatPersonName(getRowValue(row, header)) }}
            </span>
            <span
              v-else
              v-bind:class="{ 'order-number-value': header.field === 'number' }"
            >
              {{ getRowValue(row, header) }}
            </span>
          </td>
        </tr>
        <td
          :colspan="headers.length + 2"
          v-if="products.filter((x) => x?.activityId == row.id).length > 0"
        >
          <table class="order-products-inline-table" style="width: 100%; table-layout: fixed;">
            <colgroup>
              <col style="width: 33.333333%;" />
              <col style="width: 33.333333%;" />
              <col style="width: 33.333333%;" />
            </colgroup>
            <thead>
              <tr class="rounded shadow">
                <th class="text-center order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">{{
                  $filters.localize("tableColumns.common.products_Product_Code_Custom")
                }}</th>
                <th class="text-center order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">
                  {{ $filters.localize("main.size") }}
                </th>
                <th class="text-center order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">
                  {{ $filters.localize("main.countTitle") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row of products.filter((x) => x?.activityId == row.id)"
                v-bind:key="row.id"
              >
                <td class="order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">
                  {{ row.product?.code }}
                </td>
                <td class="order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">
                  {{ row.productRemain?.character?.name }}
                </td>
                <td class="order-products-inline-table__cell" style="width: 33.333333%; min-width: 33.333333%; max-width: 33.333333%;">
                  {{ row.quantity }}
                </td>
              </tr>
            </tbody>
          </table>
        </td>
      </tbody>
    </template>
  </t-section>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import SenderDetail from "@/views/details/messages/SenderDetail.vue";
import TSection from "@/components/Sections/SectionV3.vue";
import { getOrderSourceOptions } from "@/utilities/OrderSource";
import { getDeliveryServiceName, localizeDeliveryServices } from "@/utilities/DeliveryService";
export default {
  name: "OrderSection",
  components: {
    TSection,
    SenderDetail,
  },
  methods: {
    formatKind(value) {
      switch (value) {
        case "Retail":
          return this.$filters.localize("OrderPage.kind.retail");
        default:
          return this.$filters.localize("OrderPage.kind.wholesale");
      }
    },
    formatFulfillment(value) {
      return value === "Tailoring"
        ? this.$filters.localize("OrderPage.fulfillmentKind.tailoring")
        : this.$filters.localize("OrderPage.fulfillmentKind.standard");
    },
    loadLookups() {
      this.$store
        .dispatch("section", { table: "orderstatus", body: {} })
        .then((response) => {
          this.lookups.status = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "deliveryType", body: {} })
        .then((response) => {
          this.lookups.deliveryType = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "deliveryService", body: {} })
        .then((response) => {
          this.lookups.deliveryService = localizeDeliveryServices(response.data.data);
        });
      this.$store
        .dispatch("section", { table: "paymentStatus", body: {} })
        .then((response) => {
          this.lookups.paymentStatus = response.data.data;
        });
      this.$store
        .dispatch("section", { table: "paymentdetail" })
        .then((response) => {
          this.lookups.fops = response.data.data;
        });
    },
    getProducts(rootId) {
      this.$store
        .dispatch("getFilter", {
          table: "orderproduct",
          body: { id: rootId, rootColumn: "ActivityId" },
        })
        .then((response) => {
          this.products = [...this.products, ...response.data.data];
        });
    },
    removeProducts(rootId) {
      this.products = this.products.filter((x) => x?.activityId !== rootId);
    },
    routerRetail() {
      this.$router.push({
        name: "OrderPage",
        params: { id: uuidv4(), kind: "Retail" },
      });
    },
    routerTailoring(kind = "Wholesale") {
      this.$router.push({
        name: "OrderPage",
        params: { id: uuidv4(), kind: kind },
        query: { fulfillmentKind: "Tailoring" },
      });
    },
    routerOrder(row, header, openInNewTab = false) {
      if (!header?.router) {
        return;
      }

      const route = {
        name: "OrderPage",
        params: row.kind ? { id: row.id, kind: row.kind } : { id: row.id },
        query:
          row.fulfillmentKind === "Tailoring"
            ? { fulfillmentKind: "Tailoring" }
            : {},
      };

      if (openInNewTab) {
        const target = this.$router.resolve(route);
        window.open(target.href, "_blank");
        return;
      }

      this.$router.push(route);
    },
    getClassColor(value, header) {
      const type = header?.config?.type;
      if (type === "delivery") {
        switch (value) {
          case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-new-post";
          case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-ua-post";
          default:
            return null;
        }
      } else if (type === "payment") {
        switch (value) {
          case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-full-payment";
          case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-partial-payment";
          default:
            return null;
        }
      } else if (type === "paymentStatus") {
        switch (value) {
          case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-payment-status-wait";
          case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-payment-status-confirm";
          case "3bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-payment-status-not-found";
          default:
            return null;
        }
      } else if (type === "status") {
        switch (value) {
          case "1bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-new";
          case "2bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-reserv";
          case "3bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-wait";
          case "4bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-confirm";
          case "5bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-on-the-way";
          case "6bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-close";
          case "7bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-refund";
          case "8bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-cancel";
          case "9bf61851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-resort";
          case "0bf62851-347c-4d0d-a62e-d488dce9c0da":
            return "row-status-wait-confirm";
          case "124f7ab2-9af9-45af-9e66-3fefc9fca101":
            return "row-status-tailoring-confirmed";
          case "8d48c2f5-767e-45f8-a0b7-675f6cb8efb0":
            return "row-status-tailoring-production";
          case "ec6d3806-1d41-4de1-a4ff-2fd9d93f0eef":
            return "row-status-tailoring-ready";
          default:
            return null;
        }
      }
      return header?.classes ? header.classes(value) : "";
    },
    isChipHeader(row, header, getRowValue) {
      if (header?.config?.type === "paymentStatus") {
        return !!getRowValue(row, header);
      }

      return (
        header.field === "kind" ||
        header.field === "fulfillmentKind" ||
        header?.config?.type === "status" ||
        !!this.getClassColor(getRowValue(row, header.config), header)
      );
    },
    formatChipValue(value, header, row) {
      if (header?.config?.type === "delivery") {
        return header.field === "number"
          ? String(value ?? "")
          : getDeliveryServiceName({ ...row?.deliveryService, id: row?.deliveryServiceId });
      }

      const text = String(value ?? "");
      if (header?.config?.type !== "paymentStatus") {
        return text;
      }

      return text.replace(/\s*оплати\s*/gi, " ").trim();
    },
    isPersonNameHeader(header) {
      return header.field === "contact.fullName";
    },
    formatPersonName(value) {
      return String(value ?? "")
        .replace(/\s+/g, " ")
        .trim()
        .toLocaleLowerCase("uk-UA")
        .replace(/(^|[\s-])(\p{L})/gu, (_, prefix, letter) => {
          return prefix + letter.toLocaleUpperCase("uk-UA");
        });
    },
  },
  computed: {
    fields: {
      get() {
        return [
          { field: "number", name: "Номер", type: "number" },
          {
            field: "statusId",
            name: "Статус",
            type: "lookup",
            lookup: this.lookups.status,
          },
          {
            field: "kind",
            name: this.$filters.localize("OrderPage.fields.kind"),
            type: "lookup",
            lookup: [
              { name: this.$filters.localize("OrderPage.kind.wholesale"), id: "Wholesale" },
              { name: this.$filters.localize("OrderPage.kind.retail"), id: "Retail" },
            ],
          },
          {
            field: "fulfillmentKind",
            name: this.$filters.localize("OrderPage.fields.fulfillmentKind"),
            type: "lookup",
            lookup: [
              { name: this.$filters.localize("OrderPage.fulfillmentKind.standard"), id: "Standard" },
              { name: this.$filters.localize("OrderPage.fulfillmentKind.tailoring"), id: "Tailoring" },
            ],
          },
          {
            field: "source",
            name: this.$filters.localize("OrderPage.fields.source"),
            type: "lookup",
            lookup: getOrderSourceOptions(this.$filters.localize, { includeEmpty: true }),
          },
          {
            field: "paymentStatusId",
            name: "Статус оплати",
            type: "lookup",
            lookup: this.lookups.paymentStatus,
          },
          {
            field: "createdOn",
            name: this.$filters.localize("main.createdOn"),
            type: "date",
          },
          {
            field: "contact.fullName",
            name: "Відповідальний",
            type: "string",
          },
          { field: "client", name: "Клієнт (Прайс)", type: "string" },
          { field: "comment", name: "Коментар", type: "string" },
          {
            field: "deliveryServiceId",
            name: "Пошта",
            type: "lookup",
            lookup: this.lookups.deliveryService,
          },
          { field: "city", name: "Місто", type: "string" },
          { field: "recipientPhone", name: "Номер клієнта", type: "string" },
          { field: "recipient", name: "Отримувач", type: "string" },
          { field: "ttn", name: "ТТН", type: "string" },
          { field: "paymentPayer", name: "Платник", type: "string" },
          {
            field: "paymentDetailId",
            name: "ФОП (рахунок оплати)",
            type: "lookup",
            lookup: this.lookups.fops,
          },
          {
            field: "deliveryTypeId",
            name: "Тип оплати",
            type: "lookup",
            lookup: this.lookups.deliveryType,
          },
          {
            field: "products.Product.Code.Custom",
            name: "Код продукту",
            type: "all",
          },
          {
            field: "products.Character.Code.Custom",
            name: this.$filters.localize("main.size"),
            type: "all",
          },
        ];
      },
    },
  },
  data() {
    return {
      isCustomRow: true,
      products: [],
      lookups: {
        status: [],
        deliveryType: [],
        deliveryService: [],
        fops: [],
      },
      headers: [
        {
          field: "number",
          name: "Номер",
          sort: true,
          config: { field: "deliveryServiceId", type: "delivery" },
          router: { field: "id", name: "OrderPage" },
          class: "order-col-number",
        },
        {
          field: "kind",
          name: "Тип",
          title: this.$filters.localize("OrderPage.fields.kind"),
          sort: true,
          router: { field: "id", name: "OrderPage" },
          classes: (value) => (value === "Retail" ? "bg-success text-white" : ""),
          class: "order-col-kind",
        },
        {
          field: "fulfillmentKind",
          name: "Вик.",
          title: this.$filters.localize("OrderPage.fields.fulfillmentKind"),
          sort: true,
          router: { field: "id", name: "OrderPage" },
          classes: (value) => (value === "Tailoring" ? "bg-info text-white" : ""),
          class: "order-col-fulfillment",
        },
        {
          field: "contact.fullName",
          name: "Відповідальний",
          sort: true,
          router: { field: "id", name: "OrderPage" },
          class: "order-col-person",
          style: {
            whiteSpace: "nowrap",
          },
        },
        {
          field: "client",
          name: "Клієнт (Прайс) ",
          sort: true,
          router: { field: "id", name: "OrderPage" },
          class: "order-col-client",
        },
        {
          field: "createdOn",
          name: this.$filters.localize("main.createdOn"),
          isDate: true,
          sort: true,
          router: { field: "id", name: "OrderPage" },
          class: "order-col-date",
        },
        {
          field: "deliveryService.name",
          name: "Пошта",
          sort: true,
          config: { field: "deliveryServiceId", type: "delivery" },
          router: { field: "id", name: "OrderPage" },
          class: "order-col-delivery",
        },
        {
          field: "deliveryType.name",
          name: "Тип оплати",
          sort: true,
          config: { field: "deliveryTypeId", type: "payment" },
          router: { field: "id", name: "OrderPage" },
          class: "order-col-payment",
        },
        {
          field: "recipient",
          name: "Отримувач",
          sort: true,
          router: { field: "id", name: "OrderPage" },
          class: "order-col-recipient",
          style: {
            whiteSpace: "nowrap",
          },
        },
        { field: "ttn", name: "ТТН", class: "order-col-ttn" },
        {
          field: "status.name",
          name: "Статус",
          sort: true,
          config: { field: "statusId", type: "status" },
          router: { field: "id", name: "OrderPage" },
          class: "order-col-status",
        },
        {
          field: "paymentStatus.name",
          name: "Статус оплати",
          title: "Статус оплати",
          sort: true,
          config: { field: "paymentStatusId", type: "paymentStatus" },
          router: { field: "id", name: "OrderPage" },
          class: "order-col-payment-status",
        },
      ],
    };
  },
  mounted() {
    this.loadLookups();
  },
};
</script>

<style scoped>
.order-action-label--short {
  display: none;
}

:deep(.order-action-button i),
.order-action-button i {
  width: 18px;
  min-width: 18px;
  height: 18px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  line-height: 1;
  text-align: center;
}

:deep(.section-table) {
  width: 100%;
  min-width: 0;
  table-layout: auto;
}

:deep(.section-table th),
:deep(.section-table td) {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

:deep(.section-table td > span) {
  min-width: 0;
  max-width: 100%;
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
  white-space: nowrap;
}

:deep(.section-table .order-products-inline-table) {
  width: 100%;
  table-layout: fixed;
}

:deep(.section-table .order-products-inline-table__cell) {
  padding: 0.55rem 0.75rem;
  overflow: visible;
  text-align: center;
  text-overflow: clip;
  white-space: nowrap;
}

:deep(.section-table td > .order-recipient-multiline),
:deep(.section-table td > .order-recipient-singleline),
:deep(.section-table td > .order-compact-name-multiline) {
  display: block;
  overflow: hidden !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}

:deep(.section-table .order-col-number) {
  width: 68px;
  text-align: center;
}

:deep(.section-table td > .order-number-value) {
  width: 100%;
  display: block;
  text-align: center;
}

:deep(.section-table .order-col-kind) {
  width: 48px;
  max-width: 48px;
}

:deep(.section-table .order-col-fulfillment) {
  width: 56px;
  max-width: 56px;
}

:deep(.section-table .order-col-client) {
  width: 118px;
}

:deep(.section-table .order-col-person) {
  width: auto;
  min-width: max-content;
  max-width: none;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

:deep(.section-table .order-col-recipient) {
  width: auto;
  min-width: max-content;
  max-width: none;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

:deep(.section-table .order-col-person > span),
:deep(.section-table .order-col-recipient > span) {
  width: max-content;
}

:deep(.section-table .order-col-person > span) {
  max-width: none;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
}

:deep(.section-table .order-col-recipient > span) {
  display: block;
  width: max-content;
  max-width: none;
  overflow: visible !important;
  text-overflow: clip !important;
  white-space: nowrap !important;
  word-break: normal !important;
  overflow-wrap: normal !important;
}

:deep(.section-table .order-col-date) {
  width: 82px;
}

:deep(.section-table .order-col-delivery) {
  width: 82px;
}

:deep(.section-table .order-col-payment) {
  width: 96px;
}

:deep(.section-table .order-col-phone) {
  width: 108px;
}

:deep(.section-table .order-col-ttn) {
  width: 96px;
}

:deep(.section-table .order-col-status) {
  width: 126px;
}

:deep(.section-table .order-col-payment-status) {
  width: 132px;
  max-width: 132px;
}

:deep(.section-button-group > .order-action-button--opt),
:deep(.order-action-button--opt),
.order-action-button--opt {
  color: #0f7a3a;
  border-color: #86d99a;
  background: #f0fdf4;
}

:deep(.section-button-group > .order-action-button--opt:hover),
:deep(.order-action-button--opt:hover),
.order-action-button--opt:hover {
  color: #0d6832;
  background: #dcfce7;
}

:deep(.section-button-group > .order-action-button--retail),
.order-action-button--retail {
  color: #2563eb;
  border-color: #8bb8ff;
  background: #f7fbff;
}

:deep(.section-button-group > .order-action-button--retail:hover),
.order-action-button--retail:hover {
  color: #174ea6;
  background: #eef6ff;
}

:deep(.section-button-group > .order-action-button--tailoring),
.order-action-button--tailoring {
  color: #0f766e;
  border-color: #7dd3c7;
  background: #f0fdfa;
}

:deep(.section-button-group > .order-action-button--tailoring:hover),
.order-action-button--tailoring:hover {
  color: #115e59;
  background: #ccfbf1;
}

:deep(.section-button-group > .order-action-button--tailoring-retail),
.order-action-button--tailoring-retail {
  color: #7c3aed;
  border-color: #c4b5fd;
  background: #faf7ff;
}

:deep(.section-button-group > .order-action-button--tailoring-retail:hover),
.order-action-button--tailoring-retail:hover {
  color: #5b21b6;
  background: #f1eaff;
}

.order-chip {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 26px;
  max-width: 100%;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: inherit;
  font-weight: 400;
  line-height: 1.15;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.order-chip--payment-status {
  max-width: 100%;
  min-height: 26px;
  white-space: nowrap;
}

.order-chip-cell {
  text-align: center;
}

.row-new-post {
  background-color: #239ef0;
  color: white;
}

.row-ua-post {
  background-color: #05be0e;
  color: white;
}

.row-full-payment {
  background-color: #ffd375;
  color: white;
}

.row-partial-payment {
  background-color: #bb0303;
  color: white;
}

.row-payment-status-wait {
  background-color: #fff7d6;
  border: 1px solid #f2d46b;
  color: #513f00;
}

.row-payment-status-confirm {
  background-color: #16a34a;
  color: white;
}

.row-payment-status-not-found {
  background-color: #bb0303;
  color: white;
}

.row-superimposed {
  background-color: #8f3030;
  color: white;
}

.row-full-payment {
  background-color: #ffd375;
  color: white;
}

.row-status-new {
  background-color: #eef3f8;
  border: 1px solid #d6dee8;
  color: black;
}

.row-status-wait {
  background-color: #8500b9;
  color: white;
}

.row-status-reserv {
  background-color: #6b7f69;
  color: white;
}

.row-status-confirm {
  background-color: #fff7d6;
  border: 1px solid #f2d46b;
  color: black;
}

.row-status-wait-confirm {
  background-color: #239ef0;
  color: white;
}

.row-status-tailoring-confirmed {
  background-color: #0f766e;
  color: white;
}

.row-status-tailoring-production {
  background-color: #2563eb;
  color: white;
}

.row-status-tailoring-ready {
  background-color: #16a34a;
  color: white;
}

.row-status-on-the-way {
  background-color: #05be0e;
  color: white;
}

.row-status-close {
  background-color: #5e5e5e;
  color: white;
}

.row-status-refund {
  background-color: #693b3b;
  color: white;
}

.row-status-cancel {
  background-color: #8f3030;
  color: white;
}

.row-status-resort {
  background-color: #8f3030;
  color: white;
}

.row-status-default {
  background-color: #eef3f8;
  border: 1px solid #d6dee8;
  color: #243447;
}

@media (max-width: 767.98px) {
  .order-action-button {
    display: inline-grid;
    grid-template-columns: 30px minmax(0, 1fr);
    align-items: center;
    justify-items: center;
    column-gap: 4px;
    white-space: nowrap;
  }

  :deep(.order-action-button i),
  .order-action-button i {
    width: 30px;
    min-width: 30px;
    height: 30px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    line-height: 1;
    text-align: center;
  }

  .order-action-button .order-action-label {
    min-width: 0;
    flex: 0 1 auto;
    text-align: center;
  }

  .order-action-button .order-action-label--full {
    display: none;
  }

  .order-action-button .order-action-label--short {
    display: inline;
    white-space: nowrap;
  }
}
</style>
